module.exports = __webpack_public_path__ + "static/img/13.bdb7cdd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/4/sp/13.png
// module id = KKhH
// module chunks = 0